<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Drink the Tea</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<link href="../page-template.xpgt" rel="stylesheet" type="application/vnd.adobe-page-template+xml"/>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<h1 class="book-title"><a id="page_iii"></a>DRINK THE TEA</h1>
<p class="image1"><img alt="Image" src="images/line.gif"/></p>
<p class="image1"><img alt="Image" src="images/cup.gif"/><br/><em>a mystery</em></p>
<p class="author">THOMAS KAUFMAN</p>
<p class="image1"><img alt="Image" src="images/line.gif"/></p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="editor"><img alt="Image" src="images/pub.gif"/></p>
<p class="editor">MINOTAUR BOOKS</p>
<p class="editor">New York</p>
<p class="editor"><img alt="Image" src="images/pub1.gif"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?2ea4fc44